import { AGENT_URL } from './agentUrl';

/**
 * 에이전트에서 넘어온 돌아갈 주소 검증 (backend/utils/returnUrl.js 와 같은 규칙)
 * 허용: localhost·사설 IP·REACT_APP_AGENT_URL. 그 외 주소는 오픈 리다이렉트가 되므로 버린다.
 */
const PRIVATE_HOST_RE =
  /^(localhost|127\.\d+\.\d+\.\d+|10\.\d+\.\d+\.\d+|192\.168\.\d+\.\d+|172\.(1[6-9]|2\d|3[01])\.\d+\.\d+)$/;

const agentOrigin = () => {
  try {
    return new URL(AGENT_URL).origin;
  } catch {
    return null;
  }
};

/** 허용된 주소면 origin + pathname 만 남겨 반환, 아니면 '' */
export const sanitizeReturnUrl = (raw) => {
  if (!raw) return '';
  let url;
  try {
    url = new URL(String(raw));
  } catch {
    return '';
  }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') return '';
  if (!PRIVATE_HOST_RE.test(url.hostname) && url.origin !== agentOrigin()) return '';
  return `${url.origin}${url.pathname}`;
};

/** 돌아갈 주소로 이동. email 이 있으면 쿼리로 넘긴다 */
export const goToReturnUrl = (returnUrl, email = '', extra = {}) => {
  const url = new URL(returnUrl);
  if (email) url.searchParams.set('email', email);
  Object.entries(extra).forEach(([k, v]) => url.searchParams.set(k, v));
  window.location.href = url.toString();
};
